import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Image from "./Images/Gate.jpg";
import Image2 from "./Images/Back Building.jpg";
import Image3 from "./Images/Poster.jpg";
import './Footer.css';
import './Intro.css';
import './SlideOverlay.css'; 
import "./responsive.css";


const Home = () => {
  const [showMore, setShowMore] = useState(false);

  const toggleContent = () => {
    setShowMore(prev => !prev);
  };

  return (
    
    <div>
      {/* Home Container */}
      <div className="home-container">
        {/* Carousel */}
        <Carousel>
          <Carousel.Item>
            <img
              className="d-block w-100"
              src={Image2}
              alt="School Campus"
            />
              {/* Overlay text with animation */}
              <div className="overlay-text">Admission Open 2025-26</div>
          
            <Carousel.Caption>
              <h3>Beautiful Campus</h3>
              <p>Explore our well-maintained school campus with modern facilities.</p>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src={Image}
              alt="Classroom"
            />
             <div className="overlay-text">Admission Open 2025-26</div>
            <Carousel.Caption>
              <h3>State-of-the-Art Classrooms</h3>
              <p>Our classrooms are equipped with the latest technology to enhance learning.</p>
            </Carousel.Caption>
          </Carousel.Item>

          <Carousel.Item>
            <img
              className="d-block w-100"
              src={Image2}
              alt="Library"
            />
             <div className="overlay-text">Admission Open 2025-26</div>
            <Carousel.Caption>
              <h3>Library Resources</h3>
              <p>A rich collection of books and digital resources for all students.</p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>

        <div className="container">
          <div className="school-intro">
            <div className="image-section">
              <img 
                src={Image3}
                alt="Students in Classroom" 
                className="intro-image" 
              />
            </div>
            <div className="text-section">
            <link
             href="https://fonts.googleapis.com/css2?family=Almendra+SC&display=swap" rel="stylesheet" />
            <h2 style={{
                fontFamily: 'Almendra SC, serif',
                fontSize: '40px',
                fontWeight: 'bold',
                color: '#00008B',
                letterSpacing: '2px',
                textShadow: '2px 2px 4px #aaa',
            }}>
                WELCOME TO SAVITRI SCHOOL
            </h2>
             <p>
                At Savitri Balika Inter College, we are committed to empowering young minds to become lifelong learners, critical thinkers, and responsible citizens. With a vision to deliver holistic education, we blend academic excellence with strong values, creativity, and leadership skills.
              </p>
              <p><b><u>
              We are delighted to announce that all our students in the recent board examinations scored above 90%</u></b> demonstrating their dedication, hard work, and the unwavering support of our experienced faculty. This remarkable achievement highlights the quality of education, strong values, and holistic approach we offer at Savitri Balika Inter College.
              </p>
              <p>
                Congratulations to our brilliant students for setting new benchmarks of success! We remain committed to nurturing young minds, empowering them to excel academically, and equipping them with the skills needed to thrive in today’s competitive world.
              </p>

              {/* Extra Content Section */}
              {showMore && (
                <div className="additional-content">
                  <p>✨ Unlock the Future of Learning at Savitri Balika Inter College! Click to Discover More.
                  </p>
                  {/* You can add more details or components here */}
                </div>
              )}

              <button 
                className="learn-more-btn" 
                onClick={toggleContent}
              >
                {showMore ? "Show Less" : "Learn More"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;

